import styled from "styled-components";
import theme from "../../../../styles/theme";

export const ColContainer = styled.div`
  display: flex;
  flex-direction: column;
  .top {
    font-size: ${theme.fontSize.mm};
  }
  .bottom {
    font-size: ${theme.fontSize.sm};
    color: #777986;
  }
`;
